<template>
    <rkm-modal
        persistent
        ref="Modal"
        title="Prioridade"
    >
        <rkm-form
            v-if="loaded"
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        disabled
                        label="Prioridade atual"
                        v-model="form.prioridadeAtualNome"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.prioridades"
                        :validations="validations.prioridade"
                        label="Alterar prioridade para"
                        show-default-option
                        text-field="nome"
                        v-model="model.prioridadeId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-textarea
                        :validations="validations.motivo"
                        label="Motivo"
                        v-model="model.motivo"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Vuex.
import { mapActions, mapGetters } from 'vuex'

// Mixins.
import { repository, error, object, stringCase } from '@/mixins'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        validations() {

            return {
                prioridade: { required: true },
                motivo: { required: true, max: 200 },
            }
        }
    },
    created() {

        this.repositories = {
            fila: this.getConectaSusRepository('regulacao.fila'),
        }
    },
    data: () => ({
        loaded: false,
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open() {

            this.loaded = false

            this.load()
            this.$refs.Modal.show()
        },
        load() {

            this.setLoading()

            this.repositories.fila.editPrioridade(this.solicitacao.id)
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate().then(valid => {

                if (!valid) return

                this.setLoading()

                this.repositories.fila.updatePrioridade(this.solicitacao.id, this.prepareData())
                    .then(() => {

                        this.$emit('save')
                        this.$refs.Modal.hide()
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            })
        },
        prepareData() {

            const data = this.clone(this.model)

            return this.camelObjectKeysToSnakeRecursive(data)
        },
    },
    mixins: [repository, error, object, stringCase],
    props: {
        solicitacao: { type: Object, required: true },
    }
}
</script>